



import Card from 'react-bootstrap/Card';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';



export const PageHeader = ({ title, intro, childrenRowCols, children }) => {
    var childrenRow = {
        column: {
            xs: 11,
            sm: 9,
            md: 11,
            lg: 9,
            xl: 8,
            //xxl: 'auto'
        }
    }

    const getChildrenRowCols = () => {
        if(childrenRowCols!=null){
            return childrenRowCols;
        }
        else{
            return childrenRow;
        }
    }

    return (
        <div className="public-header m-0">
            <Col className={children != null ? "ms-auto me-auto pt-2" : "ms-auto me-auto pt-2 pb-2"} lg={7} >
                <h1 id="mainContent" className="displayL bold color-white text-center " >{title}</h1>
                <p className="header4 public-intro">{intro}</p>
            </Col>
            {   
                children != null
                ?   <Col className="pb-2" {...(getChildrenRowCols().column)} /*xs={11} sm={9} md={11} lg={9} xl="8"*/>
                        {children}
                    </Col>
                :   null
            }
            
        </div>
    );
}



export const LeftPageHeader = ({ subTitle, title, intro, children, rightContent }) => {

    var topRow = {
        column1: {
            xs: 11,
            sm: 9,
            md: 6,
            lg: 5,
            xl: 4,
            //xxl:
        },
        column2: {
            xs: 11,
            sm: 9,
            md: 5,
            lg: 4,
            xl: 4,
            //xxl:
        }
    }
    var bottomRow = {
        column: {
            xs: 11,
            sm: 9,
            md: 11,
            lg: 9,
            xl: 8,
            //xxl: 'auto'
        }
    }

    return (
        <div className="public-header m-0 d-flex flex-column justify-content-center w-100 g-0">
            <Row className="d-flex justify-content-center w-100 m-0 p-0 g-0" >
                
                    <Col className={children != null ? " pt-2" : " pt-2 pb-2"} /*md={6} lg={5} xl={4}*/ {...topRow.column1}>
                        <div className="text-start mb-4">
                            <span className="text-white text-start">{subTitle}</span>
                        </div>
                        <h1 id="mainContent" className={intro != null ? "displayL bold color-white text-start mb-4" : " displayL bold color-white text-start"}>{title}</h1>
                        {   intro != null 
                            ?
                                <p className="header4 public-intro text-start" >{intro}</p>
                            : null 
                        }
                    </Col>
                    <Col className={children != null ? " " : "  pb-2"} /*md={5} lg={4} xl={4}*/ {...topRow.column2}>
                        {rightContent}
                    </Col>
                
            </Row>
            {   
                children != null? 
                    <Row className="d-flex justify-content-center w-100 m-0 p-0 g-0">
                        <Col className="pb-2" /*xs={11} sm={9} md={11} lg={9} xl="8"*/ {...bottomRow.column}> 
                            {children}
                        </Col>   
                    </Row>
                    :   null
                }
            
        </div>
    );
}